module.exports = __webpack_public_path__ + "HP_Latex_R530_3d_art.jpg?746526b58d520ea1312640dd50b11f7b";